import { render, staticRenderFns } from "./EMelderComponentMeldenFormular.vue?vue&type=template&id=5832d124&scoped=true"
import script from "./EMelderComponentMeldenFormular.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5832d124",
  null
  
)

export default component.exports